import { NgModule } from '@angular/core';
import { Apttus3Component } from './apttus3.component';

@NgModule({
  imports: [
  ],
  declarations: [Apttus3Component],
  exports: [Apttus3Component]
})
export class Apttus3Module { }
